enum AutoLockAction {
    LOCK_ORDER = "LOCK_ORDER",

    NONE = "NONE",
}

export default AutoLockAction;
